// Single source of truth for the English (raw kayenta_stories story_person role)
// → Swedish label + pill color. Consumed by network's PersonDetail.js (story
// involvement pill) and kayentaStories' Participants.js (role pill + filter) —
// previously each re-implemented this mapping independently, which is how a
// story role once rendered as the raw English word with no pill color on the
// Nätverk person page.
export const STORY_ROLES = {
  speaker:     { code: 'talare',    label: 'Talare',    pillClassName: 'pill pill-gold' },
  participant: { code: 'deltagare', label: 'Deltagare', pillClassName: 'pill pill-blue' },
}

export const getStoryRole = (role) => STORY_ROLES[role] || { code: role, label: role, pillClassName: 'pill' }
